"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlHistory = exports.ComponentType = exports.AppType = void 0;
var rxjs_1 = require("rxjs");
var AppType;
(function (AppType) {
    AppType[AppType["subApp"] = 1] = "subApp";
    AppType[AppType["widget"] = 2] = "widget";
})(AppType = exports.AppType || (exports.AppType = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType[ComponentType["navigation"] = 1] = "navigation";
    ComponentType[ComponentType["coreNavigation"] = 2] = "coreNavigation";
    ComponentType[ComponentType["dashboard"] = 3] = "dashboard";
    ComponentType[ComponentType["notification"] = 4] = "notification";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var UrlHistory = /** @class */ (function () {
    function UrlHistory() {
        var _this = this;
        this._historyInstance = null;
        this.$historyUrl = new rxjs_1.BehaviorSubject('');
        this.onHistoryUrl = function () { return _this.$historyUrl.asObservable(); };
    }
    UrlHistory.prototype.setHistoryInstance = function (instance) {
        this._historyInstance = instance;
        if (instance.location.pathname !== this.$historyUrl.getValue()) {
            this.$historyUrl.next(instance.location.pathname);
        }
    };
    UrlHistory.prototype.push = function (url) {
        this._historyInstance.push(url);
    };
    UrlHistory.prototype.currentUrl = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._historyInstance) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.pathname) !== null && _c !== void 0 ? _c : '';
    };
    return UrlHistory;
}());
exports.UrlHistory = UrlHistory;
